import { type FC, useCallback } from 'react';

import { PikInNumbersV2 } from './PikInNumbersV2';
import { trackShowPikInNumbersSection } from './internal/tracking/trackShowPikInNumbersSection';

export const PikInNumbersV2Container: FC = () => {
  const handleView = useCallback(() => trackShowPikInNumbersSection(), []);

  return <PikInNumbersV2 onView={handleView} />;
};
